import { commonUtil } from '@/util'

const request = {}

request.createRequest = function (customerData) {
  const recipientList = customerData.recipientList.map((ele) => {
    return {
      recipientName: ele.recipientInfoLine1.recipientName,
      recipientOrganizationName:
        ele.recipientInfoLine1.recipientOrganizationName,
      recipientAddressCountryId: ele.recipientInfoLine2.country.value,
      recipientPostalCode: ele.recipientInfoLine2.recipientPostalCode
        ? ele.recipientInfoLine2.recipientPostalCode
        : null,
      recipientRegionId: commonUtil.nullEmptyFormatNull(
        commonUtil.formatRegion(ele.recipientInfoLine2.recipientRegion, true)
      ),
      recipientRegion: commonUtil.nullEmptyFormatNull(
        commonUtil.formatRegion(ele.recipientInfoLine2.recipientRegion, false)
      ),
      recipientAddress1: ele.recipientInfoLine2.recipientAddress1,
      recipientAddress2: ele.recipientInfoLine2.recipientAddress2
        ? ele.recipientInfoLine2.recipientAddress2
        : null,
      recipientPhoneNumberCountryId:
        ele.recipientInfoLine1.recipientPhone.countryCode.value,
      recipientPhoneNumber: ele.recipientInfoLine1.recipientPhone.phoneNumber,
      recipientNote: ele.recipientInfoLine1.recipientNote
        ? ele.recipientInfoLine1.recipientNote
        : null,
      recipientSortNumber: ele.recipientInfoLine1.recipientSortNumber
    }
  })

  return {
    organizationName: customerData.customerInfoLine1.organizationName
      ? customerData.customerInfoLine1.organizationName
      : null,
    sectionName: customerData.customerInfoLine1.sectionName
      ? customerData.customerInfoLine1.sectionName
      : null,
    rep: customerData.customerInfoLine1.rep,
    alphabet: customerData.customerInfoLine1.alphabet
      ? customerData.customerInfoLine1.alphabet
      : null,
    phoneNumberCountryId: customerData.customerInfoLine2.phone.countryCode.value
      ? customerData.customerInfoLine2.phone.countryCode.value
      : null,
    phoneNumber: customerData.customerInfoLine2.phone.phoneNumber
      ? customerData.customerInfoLine2.phone.phoneNumber
      : null,
    mailAddress: customerData.customerInfoLine2.mailAddress
      ? customerData.customerInfoLine2.mailAddress
      : null,
    wechatId: customerData.customerInfoLine2.wechatId
      ? customerData.customerInfoLine2.wechatId
      : null,
    shopName: customerData.customerInfoLine2.shopName
      ? customerData.customerInfoLine2.shopName
      : null,
    url: customerData.customerInfoLine2.url
      ? customerData.customerInfoLine2.url
      : null,
    billingOrganizationName: customerData.invoiceInfoLine1
      .billingOrganizationName
      ? customerData.invoiceInfoLine1.billingOrganizationName
      : null,
    billingSectionName: customerData.invoiceInfoLine1.billingSectionName
      ? customerData.invoiceInfoLine1.billingSectionName
      : null,
    billingName: customerData.invoiceInfoLine1.billingName
      ? customerData.invoiceInfoLine1.billingName
      : null,
    billingAddressCountryId: customerData.invoiceInfoLine2.country.value
      ? customerData.invoiceInfoLine2.country.value
      : null,
    billingPostalCode: customerData.invoiceInfoLine2.billingPostalCode
      ? customerData.invoiceInfoLine2.billingPostalCode
      : null,
    billingRegionId: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(customerData.invoiceInfoLine2.billingRegion, true)
    ),
    billingRegion: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(
        customerData.invoiceInfoLine2.billingRegion,
        false
      )
    ),
    billingAddress1: customerData.invoiceInfoLine2.billingAddress1
      ? customerData.invoiceInfoLine2.billingAddress1
      : null,
    billingAddress2: customerData.invoiceInfoLine2.billingAddress2
      ? customerData.invoiceInfoLine2.billingAddress2
      : null,
    billingPhoneNumberCountryId: customerData.invoiceInfoLine1.billingPhone
      .countryCode.value
      ? customerData.invoiceInfoLine1.billingPhone.countryCode.value
      : null,
    billingPhoneNumber: customerData.invoiceInfoLine1.billingPhone.phoneNumber
      ? customerData.invoiceInfoLine1.billingPhone.phoneNumber
      : null,
    paymentCriteria: customerData.customerInfoLine1.paymentCriteria
      ? customerData.customerInfoLine1.paymentCriteria
      : null,
    customerCategoryId: customerData.customerInfoLine1.customerCategoryId,
    customerNote: customerData.customerInfoLine2.customerNote
      ? customerData.customerInfoLine2.customerNote
      : null,
    isEnabled: customerData.customerInfoLine2.isEnabled,
    rateAccount: customerData.customerInfoLine1.rateAccount,
    recipientList: recipientList
  }
}
export default { request }
